import { FunctionComponent, useState } from 'react'
import { PostCategory } from '@/types/NewsFeed.ts'
import styles from '@/container/daycare/daycareProfile/newsSettings/newsSettings.module.scss'
import { TableCell, TableRow } from '@mui/material'
import { Delete, Edit } from '@mui/icons-material'
import UpdatePostCategoryDialog from '@/container/daycare/daycareProfile/newsSettings/postCategories/UpdatePostCategoryDialog.tsx'
import ConfirmDeletePostCategoryDialog from '@/container/daycare/daycareProfile/newsSettings/postCategories/ConfirmDeletePostCategoryDialog.tsx'

interface PostCategoryRowProps {
    daycareId: number
    category: PostCategory
    canUpdate: boolean
    refetch: () => void
}

const PostCategoryRow: FunctionComponent<PostCategoryRowProps> = ({
    daycareId,
    category,
    canUpdate,
    refetch
}: PostCategoryRowProps) => {
    const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState<boolean>(false)
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false)

    return (
        <>
            <TableRow>
                <TableCell align={'center'} className={styles.RowText}>
                    {category.name}
                </TableCell>
                {canUpdate && (
                    <>
                        <TableCell sx={{ width: '5%' }} align={'center'}>
                            <Edit className={styles.Icon} onClick={() => setIsUpdateDialogOpen(true)} />
                        </TableCell>
                        <TableCell sx={{ width: '5%' }} align={'center'}>
                            <Delete className={styles.Icon} onClick={() => setIsDeleteDialogOpen(true)} />
                        </TableCell>
                    </>
                )}
            </TableRow>
            <UpdatePostCategoryDialog
                open={isUpdateDialogOpen}
                handleClose={() => setIsUpdateDialogOpen(false)}
                refetch={refetch}
                daycareId={daycareId}
                category={category}
            />
            <ConfirmDeletePostCategoryDialog
                open={isDeleteDialogOpen}
                handleClose={() => setIsDeleteDialogOpen(false)}
                daycareId={daycareId}
                category={category}
                refetch={refetch}
            />
        </>
    )
}

export default PostCategoryRow
